import React, { useEffect, useRef } from 'react';
import { X } from 'lucide-react';
import { Z_INDEX } from '../../utils/constants';

const Modal = ({ title, children, isOpen, onClose }) => {
  const closeBtnRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    closeBtnRef.current?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-slate-900/40 dark:bg-black/70 backdrop-blur-sm flex items-center justify-center animate-in fade-in p-4 pt-[max(1rem,env(safe-area-inset-top))] overflow-y-auto"
      style={{ zIndex: Z_INDEX.modal }}
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        className="bg-white dark:bg-slate-900 rounded-3xl shadow-2xl w-full max-w-lg overflow-hidden border border-slate-100 dark:border-slate-800 flex flex-col transition-colors my-auto max-h-[calc(100dvh_-_env(safe-area-inset-top)_-_env(safe-area-inset-bottom)_-_2rem)]"
      >
        <div className="flex justify-between items-center p-4 sm:p-6 border-b border-slate-100/80 dark:border-slate-800 bg-gradient-to-b from-slate-50/80 to-white dark:from-slate-800/60 dark:to-slate-900 shrink-0">
          <h3 id="modal-title" className="font-bold text-base sm:text-lg text-slate-800 dark:text-white">
            {title}
          </h3>
          <button
            ref={closeBtnRef}
            type="button"
            onClick={onClose}
            aria-label="Kapat"
            className="p-2 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-500/20 rounded-full transition-colors shadow-sm"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-4 sm:p-6 overflow-y-auto custom-scrollbar flex-1 min-h-0">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
